module.exports = __webpack_public_path__ + "img/ic_person.45c1af20.svg";